import { defineStore } from "pinia";

export const useStudyStore = defineStore({
  id: "study",
  state: () => ({
    study: {
      name: "",
      status: ""
    },
    activeOrg: {},
    config: {},
    zones: [],
    roads: null,
    artifacts: {
      PO: {},
      POS: {},
      LA: {},
      LAS: {},
      DF: {},
      ZF: {},
      CF: {}
    }
  }),
  actions: {
    reset() {
      this.study = {};
      this.config = {};
      this.zones = [];
      this.roads = null;
      this.artifacts = {
        PO: {},
        POS: {},
        LA: {},
        LAS: {},
        DF: {},
        ZF: {},
        CF: {}
      };
    }
  }
});
